import { mockApiClient } from "./mockApiClient";

export const apiClient = mockApiClient;